import utils from "utils";
class buyerListCtrl {
    constructor(
        $scope,
        httpRequest,
        $state,
        $stateParams,
        sweetalert,
        logger,
        initSortService
    ) {
        $scope.exportCollapsed = false;
        const aMonth = utils.genPeriodByMonth();
        $scope.queryParam = {
            pageSize: 10,
            pageNum: 1,
            param: {
                customerName: "",
                taxplayerType: "",
                creditCode: "",
                status: "",
                updateTimeStart: aMonth.start,
                updateTimeEnd: aMonth.end,
                email: "",
                mobile: "",
                legalName: "",
            },
        };
        $scope.reset = function () {
            $scope.queryParam.param = {
                customerName: "",
                taxplayerType: "",
                creditCode: "",
                status: "",
                updateTimeStart: aMonth.start,
                updateTimeEnd: aMonth.end,
                email: "",
                mobile: "",
                legalName: "",
            };
        };
        // 选中的购方信息
        $scope.selectedBuyers = [];
        // $scope.reset()
        // 表头排序
        $scope.orderMap = initSortService("buyerParam");
        $scope.selectedHandle = function () {
            $scope.queryParam.orderMap = {};
            if ($scope.orderMap.sortKey)
                $scope.queryParam.orderMap[$scope.orderMap.sortKey] =
                    $scope.orderMap.sortVal;
            sessionStorage.setItem("buyerParam", JSON.stringify($scope.queryParam));
            $scope.queryOrgInfo();
        };
        const queryOrgInfo = function queryOrgInfo() {
            $scope.queryParam = sessionStorage.buyerParam
                ? JSON.parse(sessionStorage.buyerParam)
                : $scope.queryParam;
            const openLoading =
                $scope.queryParam.pageSize >= 100
                    ? window.layer.msg("正在查询，请耐心等待", {
                        time: 0,
                        skin: "layer-loading-self",
                        icon: 16,
                        shade: 0.5,
                    })
                    : null;
            httpRequest
                .post_getPageCustomerList($scope.queryParam)
                .then((res) => {
                    $scope.listData = res.data.value.list;
                    $scope.totalItems = res.data.value.total;
                    $scope.queryParam.pageNum = res.data.value.pageNum;
                    $scope.selectedBuyers = [];
                })
                .finally(() => {
                    window.layer.close(openLoading);
                });
        };
        $scope.searchList = function () {
            sessionStorage.setItem("buyerParam", JSON.stringify($scope.queryParam));
            queryOrgInfo();
        };
        // 分页
        $scope.pageChanged = function () {
            // 点击页码发起查询
            sessionStorage.setItem(
                "buyerParam",
                JSON.stringify({
                    orderMap: $scope.queryParam.orderMap,
                    pageNum: $scope.queryParam.pageNum,
                    pageSize: $scope.queryParam.pageSize,
                    param: sessionStorage.buyerParam
                        ? JSON.parse(sessionStorage.buyerParam).param
                        : {
                            ownerRole: decodeURI($stateParams.roleName), // URL带过来的角色名称参数
                            isRoleOwner: "1", // 拥有本机构角色
                            realName: "", // 姓名
                            orgId: "", // 所属机构
                            status: "",
                            updateTimeStart: aMonth.start,
                            updateTimeEnd: aMonth.end,
                            email: "",
                            mobile: "",
                            legalName: "",
                        },
                })
            );
            queryOrgInfo();
        };
        $scope.exportExel = function exportExel() {
            // httpRequest.get_exportCustomer({
            //     accessToken: localStorage.getItem('id_token'),
            //     ...$scope.queryParam.param,
            // })
            const reqObj = $.extend({}, $scope.queryParam.param, {
                selectedIdList: $scope.selectedBuyers.map((x) => x.customerId),
            });
            let _url = `${host.etcloudOvat
                }settings/sysCustomer/exportToExcel?accessToken=${localStorage.getItem(
                    "id_token"
                )}`;
            for (let i in $scope.queryParam.orderMap) {
                reqObj.sortField = i + ":" + $scope.queryParam.orderMap[i];
            }
            utils.post_downLoad(reqObj, _url);
        };
        const typecodeArrStr = '["taxplayer_type", "status", "company_type"]';
        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            $scope.dictionary = res.data.value;
        });
        queryOrgInfo();
        $scope.queryOrgInfo = queryOrgInfo;
        $scope.tableDropdownConfig = [
            {
                label: "编辑",
                handler(item) {
                    $state.go("outputManage.ovat.buyer.edit", {
                        customerId: item.customerId,
                    });
                },
                showWhile(item, hasPermit) {
                    return hasPermit("edit_buyer");
                },
            },
            {
                label: "删除",
                handler(item) {
                    sweetalert.confirm("删除提醒", "确认删除此信息?").then(() => {
                        httpRequest
                            .post_batchDeleteSysCustomer([item.customerId])
                            .then(() => {
                                queryOrgInfo();
                            });
                    });
                },
                showWhile(item, hasPermit) {
                    return hasPermit("edit_buyer");
                },
            },
        ];
        // 批量删除
        $scope.lotDelete = function lotDelete() {
            if ($scope.selectedBuyers.length === 0) {
                logger.logError("请选择购方信息");
                return;
            }
            const customerIdList = [];
            $scope.selectedBuyers.forEach((item) => {
                customerIdList.push(item.customerId);
            });
            sweetalert
                .confirm(
                    "删除提醒",
                    `共选中${customerIdList.length}条数据，确认删除这些信息？`
                )
                .then(() => {
                    httpRequest.post_batchDeleteSysCustomer(customerIdList).then(() => {
                        queryOrgInfo();
                    });
                });
        };

        // 导入配置
        $scope.importconfig = {
            code: "CUSTOMER_INFO",
            appName: host.etcloudOvat,
            downloadAppName: host.etcloudOvat,
            url: "dlTaskService/import_CUSTOMER_INFO",
            validate: {
                pattern: ".xlsx,.xls,.xml,.txt",
                _validate: {
                    size: {
                        min: 10,
                        max: "10MB",
                    },
                    duration: {
                        min: "10s",
                        max: "5m",
                    },
                    accept: ".xlsx,.xls,.xml,.txt",
                },
            },
            callback() {
                // 回掉，可选
                queryOrgInfo();
            },
            readDiskCb(_config, handleImportRes) {
                const soap = (localStorage.soap && JSON.parse(localStorage.soap)) || {};
                if (
                    soap.status != 3 ||
                    (!localStorage.currentDiskCode && localStorage.currentDiskCode !== 0)
                ) {
                    logger.logTips("请先正常连接并启动金税盘", "warn");
                } else {
                    // if(isBwDisk&&isBwDisk==1){
                    //   logger.logTips('抱歉！该功能暂时不支持使用百望税控盘', 'warn')
                    //   return
                    // }
                    const importinglayer = layer.msg("正在同步，请耐心等待", {
                        time: 0,
                        skin: "layer-loading-self",
                        icon: 16,
                        shade: 0.5,
                    });
                    const pageIndex = 1; // 初次查金税盘页码
                    const pageSize = 500; // 每次查询长度
                    let isCompleted = false;
                    let successCount = 0; // 记录多次查询金税盘成功总数
                    const initData = {
                        code: "SYN_CUSTOMER_INFO",
                    };
                    // pageIndex: 当前查询金税盘第几页
                    // importinglayer：页面转圈动画
                    // finalResponse：若本次查询金税盘数据为0条，不再调用后端导入接口，因此记录上次导入接口的返回，供后续弹窗使用
                    let realUrl = REAL_URL.replace("8888", localStorage.soapPort);
                    const importAsBatchNo = function importAsBatchNo(
                        pageIndex,
                        importinglayer,
                        batchNo,
                        finalResponse
                    ) {
                        httpRequest
                            .post_base64DeCode({
                                invData: JSON.stringify({
                                    BM: "",
                                    SJBM: "",
                                    MC: "",
                                    SH: "",
                                    KJM: "",
                                    JM: "",
                                    DZDH: "",
                                    YHZH: "",
                                    YJDZ: "",
                                    BZ: "",
                                    PageSize: pageSize,
                                    PageIndex: pageIndex,
                                }),
                                codeType: "encode",
                            })
                            .then((res) => {
                                $.post({
                                    url: realUrl,
                                    data: {
                                        SID: "440304",
                                        SIDParam: res.data.value,
                                    },
                                    timeout: 30000,
                                }).then((data) => {
                                    const DECMSG = JSON.parse(data)
                                        .ENCMSG.replace(new RegExp("[_]", "gm"), "+")
                                        .replace(new RegExp(/(\r)/g), "")
                                        .replace(new RegExp(/(\n)/g), "");
                                    httpRequest
                                        .post_base64DeCode({
                                            invData: DECMSG,
                                            codeType: "decode",
                                        })
                                        .then((res) => {
                                            const importData = JSON.parse(res.data.value);
                                            if (!res.data.success || importData.retcode != "0") {
                                                logger.logError("查询金税盘失败");
                                                return;
                                            }
                                            if (importData.RecNo < pageSize) {
                                                isCompleted = true;
                                            }
                                            successCount += importData.RecNo;
                                            if (successCount == 0) {
                                                layer.close(importinglayer);
                                                logger.logSuccess(
                                                    importData.retmsg || "查询成功，共0条数据"
                                                );
                                                return;
                                            }
                                            // 最后一次查到金税盘0条数据，不再调用后端导入接口（无数据会报错）
                                            if (successCount > 0 && importData.RecNo == 0) {
                                                handleImportRes(
                                                    finalResponse,
                                                    importinglayer,
                                                    _config,
                                                    "同步失败"
                                                );
                                                return;
                                            }

                                            httpRequest
                                                .post_addDlBatchData({
                                                    batchNo,
                                                    data: res.data.value,
                                                })
                                                .then(
                                                    (response) => {
                                                        if (isCompleted) {
                                                            // 覆盖/跳过提示框 结果提示框
                                                            handleImportRes(
                                                                response,
                                                                importinglayer,
                                                                _config,
                                                                "同步失败"
                                                            );
                                                        } else {
                                                            importAsBatchNo(
                                                                ++pageIndex,
                                                                importinglayer,
                                                                batchNo,
                                                                response
                                                            );
                                                        }
                                                    },
                                                    (msg) => {
                                                        layer.close(importinglayer);
                                                        logger.logError(msg || "同步购方失败");
                                                    }
                                                );
                                        });
                                });
                            });
                    };

                    httpRequest.post_initBatch(initData).then((res) => {
                        const batchNo = res.data.value;
                        importAsBatchNo(pageIndex, importinglayer, batchNo, {});
                    });
                }
            },
        };
        $scope.customizedConfig = {
            version: 1.141,
            queryConfig: [
                {
                    label: "名称",
                    selected: true,
                    default: true,
                },
                {
                    label: "企业类型",
                    selected: true,
                    default: true,
                },
                {
                    label: "信用代码",
                    selected: false,
                    default: false,
                },
                {
                    label: "有效标识",
                    selected: false,
                    default: false,
                },
                {
                    label: "联系人",
                    selected: false,
                    default: false,
                },
                {
                    label: "手机",
                    selected: false,
                    default: false,
                },
                {
                    label: "邮箱",
                    selected: false,
                    default: false,
                },
                {
                    label: "更新日期",
                    selected: false,
                    default: false,
                },
            ],
            table: [
                {
                    label: "名称",
                    selected: true,
                    default: true,
                },
                {
                    label: "编号",
                    selected: true,
                    default: true,
                },
                {
                    label: "信用代码",
                    selected: true,
                    default: true,
                },
                {
                    label: '开户银行',
                    selected: true,
                    default: true,
                },
                {
                    label: '银行账号',
                    selected: true,
                    default: true,
                }, {
                    label: '地址',
                    selected: false,
                    default: false,
                }, {
                    label: '电话',
                    selected: false,
                    default: false,
                },
                {
                    label: "联系人",
                    selected: false,
                    default: false,
                },
                {
                    label: "手机",
                    selected: false,
                    default: false,
                },
                {
                    label: "邮箱",
                    selected: false,
                    default: false,
                },
                {
                    label: "企业类型",
                    selected: true,
                    default: true,
                },
                {
                    label: "有效标识",
                    selected: true,
                    default: true,
                },
                {
                    label: "身份证/组织结构代码证",
                    selected: false,
                    default: false,
                },
                {
                    label: "更新日期",
                    selected: false,
                    default: false,
                },
            ],
        };
        //导出txt
        $scope.exportTxt = function exportTxt() {
            sweetalert
                .confirm(
                    "导出txt提醒",
                    `将按照开票软件客户编码列表，导出客户编码.txt文件，可直接导入至开票软件!`
                )
                .then(() => {
                    let queryParam = sessionStorage.buyerParam
                        ? JSON.parse(sessionStorage.buyerParam)
                        : $scope.queryParam;
                    queryParam = JSON.stringify(queryParam);
                    let base64 = btoa(encodeURIComponent(queryParam)); //转base64
                    httpRequest.get_exportToTxt({
                        accessToken: localStorage.getItem("id_token"),
                        paramStr: base64,
                    });
                });
        };
    }
}
buyerListCtrl.$inject = [
    "$scope",
    "httpRequest",
    "$state",
    "$stateParams",
    "sweetalert",
    "logger",
    "initSortService",
];
export default buyerListCtrl;



// WEBPACK FOOTER //
// ./src/app/outputManage/baseData/buyer/buyerListCtrl.js